export const getPreferredLocale = (): 'en' | 'fr' => {
  return localStorage.getItem('language') === 'fr' ? 'fr' : 'en';
};

export const getSafeInternalPath = (
  candidate: string | null
): string | null => {
  if (!candidate) {
    return null;
  }

  if (!candidate.startsWith('/') || candidate.startsWith('//')) {
    return null;
  }

  const hasProtocol = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(candidate);
  if (hasProtocol) {
    return null;
  }

  return candidate;
};

export const getSafeNextFromSearch = (search: string): string | null => {
  const searchParams = new URLSearchParams(search);
  return getSafeInternalPath(searchParams.get('next'));
};

export const buildSignInRedirectUrl = (
  nextPath: string,
  locale = getPreferredLocale()
): string => {
  const params = new URLSearchParams({
    locale,
    next: nextPath,
  });

  return `/sign-in?${params.toString()}`;
};
